import st from './SocialLink.module.scss';
const SocialLink = ({icon, variant, to}) => {
    return (
        <a href={to} rel="noreferrer" target='_blank' className={variant === 'warning' ? st.wrapperLinkWarning : st.wrapperLink}>
            <div className={st.link + ' ' + icon}></div>
        </a>
    )
}
export default SocialLink;